// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&family=Roboto:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    padding: 0;
    margin: 0;
    font-family: 'Lato', sans-serif;
    background-color: #320E3B;
    color: #BCEDF6;
}

h1, h2, h3, h4, h5, h6 {
    font-family: 'Roboto', sans-serif;
}

.page-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    min-height: 100vh;
    min-height: calc(100vh - 27px);
}

.content-wrapper {
    display: block;
    width: 1000px;
    margin: auto;
    text-align: center;
    padding: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.btn-primary {
    background-color: #DDFBD2;
    color: #320E3B;
    padding: 5px 10px;
    border: 2px solid #DDFBD2;
    border-radius: 5px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    text-decoration: none;
    transition: 0.3s;
}

.btn-primary:disabled {
    background-color: #c5c5c5;
    border-color: #c5c5c5;
    color: grey;
    cursor: initial;
}

.btn-primary:not(:disabled):hover {
    background-color: #320E3B;
    color: #DDFBD2;
}

.btn-secondary {
    background-color: #BCEDF6;
    color: #320E3B;
    padding: 5px 10px;
    border: 2px solid #BCEDF6;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;
    text-decoration: none;
    transition: 0.3s;
}

.btn-secondary:disabled {
    background-color: #c5c5c5;
    border-color: #c5c5c5;
    color: grey;
    cursor: initial;
}

.btn-secondary:not(:disabled):hover {
    background-color: #320E3B;
    color: #BCEDF6;
}


.session-wrapper {
    display: block;
    text-align: center;
}

.session-wrapper svg {
    display: block;
    margin: auto;
    margin-top: 15px;
    border: 15px solid white;
    background-color: white;
}

footer {
    background-color: #4C2A85;
    width: 100%;
    padding: 5px 0;
    text-align: center;
    font-size: 14px;
    margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAEA;IACI,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;AAGA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&family=Roboto:wght@300;400;700&display=swap');\r\n\r\nhtml, body {\r\n    padding: 0;\r\n    margin: 0;\r\n    font-family: 'Lato', sans-serif;\r\n    background-color: #320E3B;\r\n    color: #BCEDF6;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n    font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.page-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n    min-height: 100vh;\r\n    min-height: calc(100vh - 27px);\r\n}\r\n\r\n.content-wrapper {\r\n    display: block;\r\n    width: 1000px;\r\n    margin: auto;\r\n    text-align: center;\r\n    padding: 10px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.btn-primary {\r\n    background-color: #DDFBD2;\r\n    color: #320E3B;\r\n    padding: 5px 10px;\r\n    border: 2px solid #DDFBD2;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    transition: 0.3s;\r\n}\r\n\r\n.btn-primary:disabled {\r\n    background-color: #c5c5c5;\r\n    border-color: #c5c5c5;\r\n    color: grey;\r\n    cursor: initial;\r\n}\r\n\r\n.btn-primary:not(:disabled):hover {\r\n    background-color: #320E3B;\r\n    color: #DDFBD2;\r\n}\r\n\r\n.btn-secondary {\r\n    background-color: #BCEDF6;\r\n    color: #320E3B;\r\n    padding: 5px 10px;\r\n    border: 2px solid #BCEDF6;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    transition: 0.3s;\r\n}\r\n\r\n.btn-secondary:disabled {\r\n    background-color: #c5c5c5;\r\n    border-color: #c5c5c5;\r\n    color: grey;\r\n    cursor: initial;\r\n}\r\n\r\n.btn-secondary:not(:disabled):hover {\r\n    background-color: #320E3B;\r\n    color: #BCEDF6;\r\n}\r\n\r\n\r\n.session-wrapper {\r\n    display: block;\r\n    text-align: center;\r\n}\r\n\r\n.session-wrapper svg {\r\n    display: block;\r\n    margin: auto;\r\n    margin-top: 15px;\r\n    border: 15px solid white;\r\n    background-color: white;\r\n}\r\n\r\nfooter {\r\n    background-color: #4C2A85;\r\n    width: 100%;\r\n    padding: 5px 0;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    margin-top: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
